import { render, staticRenderFns } from "./document-folder.vue?vue&type=template&id=ce829562"
import script from "./document-folder.vue?vue&type=script&lang=js"
export * from "./document-folder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports